import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { EntityHeaderWatchlist } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/entity-header-watchlist/EntityHeaderWatchlist';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SubCategoryActionTypeWrapper = styled.div`
  ${typographyV2.titleSm};
  color: var(--text-soft);
  margin-bottom: 10px;
  display: flex;
`;

export const Title = styled.div`
  ${typographyV2.titleLg};
  color: var(--text-default);
`;

export const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ThemeTitle = styled.div`
  ${typographyV2.bodySm}
  color: var(--text-soft);
`;

export const ThemeTitleWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const TitleGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  row-gap: 0;
`;

export const WatchlistRow = styled.div`
  grid-column: 1 / -1;
  ${EntityHeaderWatchlist.Styled.ContentWrapper} {
    margin-bottom: 0;
  }
`;

export const ChartRow = styled.div`
  grid-column: 1 / -1;
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '400px',
        borderRadius: '8px',
      },
    },
  ],
})`
  margin-top: 8px;
`;
